export default __webpack_public_path__ + "static/media/More_button.8a470388.svg";